import { render, staticRenderFns } from "./HIPAA.vue?vue&type=template&id=38a6fa3e&scoped=true"
import script from "./HIPAA.vue?vue&type=script&lang=ts"
export * from "./HIPAA.vue?vue&type=script&lang=ts"
import style0 from "./HIPAA.vue?vue&type=style&index=0&id=38a6fa3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6fa3e",
  null
  
)

export default component.exports